<template>
  <v-container class="custom-container responsive-height">
    <v-row dense>
      <v-col cols="12" sm="12" md="6" class="custom-height-min">
        <v-card class="deposit-form create-account-form" color="transparent">
          <v-form ref="step1Form" v-model="step1Valid" lazy-validation>
            <v-row dense>
              <!-- Bank Name -->
              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-text-field v-model="bankInfo.bank_name" label="Enter Bank Name" single-line solo
                    class="custom-select" :rules="[rules.required]"></v-text-field>
                </fieldset>
              </v-col>

              <!-- Bank Account Name -->
              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>Bank Account Name</legend>
                  <v-text-field v-model="bankInfo.bank_acc_name" label="Bank Account Name" single-line solo
                    class="custom-select" :rules="[rules.required]"></v-text-field>
                </fieldset>
              </v-col>

              <!-- Account No -->
              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>Account No</legend>
                  <v-text-field v-model="bankInfo.bank_acc_num" label="Account No" single-line solo
                    class="custom-select" :rules="[rules.required, rules.numeric]"></v-text-field>
                </fieldset>
              </v-col>

              <!-- Optional Fields -->
              <!-- <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>IBAN Number</legend>
                  <v-text-field v-model="bankInfo.bank_iban_num" label="IBAN Number" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col> -->

              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>IFSC Code</legend>
                  <v-text-field v-model="bankInfo.ifsc_code" label="IFSC Code" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <!-- <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>Bank Swift Code</legend>
                  <v-text-field v-model="bankInfo.bank_swift_num" label="Bank Swift Code" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col> -->

              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>Bank Country</legend>
                  <v-select v-model="bankInfo.bank_residence_country" :rules="[rules.required]" :items="countries" item-text="name"
                    item-value="id" @change="onCountryChange" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>State Province</legend>
                  <v-select v-model="bankInfo.bank_residence_state" :items="states" item-text="name" item-value="id"
                    @change="onStateChange" solo append-icon="mdi-chevron-down" label="Select One" class="custom-select"
                    hide-details></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>City</legend>
                  <v-select v-model="bankInfo.bank_residence_city" :items="cities" item-text="name" item-value="id"
                    @change="onCityChange" solo append-icon="mdi-chevron-down" label="Select One" class="custom-select"
                    hide-details></v-select>
                </fieldset>
              </v-col>

              <!-- <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>Postal Code</legend>
                  <v-text-field v-model="bankInfo.bank_postal_code" label="Enter here" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col> -->

              <v-col cols="12" class="mb-from">
                <fieldset>
                  <legend>Bank Address</legend>
                  <v-text-field v-model="bankInfo.bank_address" :rules="[rules.required]" label="Enter here" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-card-actions class="pa-0 mt-5">
                <v-btn
                  class="ma-0 text-capitalize btn-account"
                  color="greenMain"
                  tile
                  width="146px"
                  elevation="0"
                  :loading="loading"
                  :disabled="loading || !step1Valid"
                  @click="handleSubmit"
                >
                  Create Account
              </v-btn>
              </v-card-actions>
            </v-row>
          </v-form>
        </v-card>
       </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  BANK__ACTIONS,
  COUNTRIES__ACTIONS,
  CITIES__ACTIONS,
  STATES__ACTIONS
} from "@/store/action-types";

export default {
  name: "BankForm",
  data() {
    return {
      e1: 1,
      step1Valid: false,
      loading: false,
      bankInfo: {
        bank_name: "",
        bank_acc_name: "",
        bank_acc_num: "",
        bank_iban_num: "N/A",
        bank_swift_num: "N/A",
        ifsc_code: "N/A",
        bank_postal_code: "",
        bank_residence_country: "",
        bank_residence_state: "",
        bank_residence_city: "",
        bank_address: "N/A"
      },
      rules: {
        required: v => (v !== null && v !== undefined && String(v).trim() !== '') || 'This field is required',
        numeric: v => (!v || /^[0-9]+$/.test(String(v))) || 'Input must be numeric',
      },
    };
  },
  computed: {
    ...mapState("countries", ["countries"]),
    ...mapState("cities", ["cities"]),
    ...mapState("states", ["states"])
  },
  methods: {
    ...mapActions("bank", [BANK__ACTIONS.CREATE]),
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),

    async onCountryChange(value) {
      this.bankInfo.bank_residence_country = value;
      this.bankInfo.bank_residence_state = "";
      this.bankInfo.bank_residence_city = "";
      await this[STATES__ACTIONS.STATES](value);
    },

    async onStateChange(value) {
      this.bankInfo.bank_residence_state = value;
      this.bankInfo.bank_residence_city = "";
      await this[CITIES__ACTIONS.CITIES](value);
    },

    onCityChange(value) {
      this.bankInfo.bank_residence_city = value;
    },

    async handleSubmit() {
      this.loading = true;
      const isValid = this.$refs.step1Form?.validate();
      if (!isValid) {
        this.loading = false;
        return;
      }

      try {
        await this[BANK__ACTIONS.CREATE](this.bankInfo);
        this.resetForm();
      } catch (error) {
        console.error('Error creating bank account:', error);
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.bankInfo = {
        bank_name: "",
        bank_acc_name: "",
        bank_acc_num: "",
        bank_iban_num: "",
        bank_swift_num: "",
        ifsc_code: "",
        bank_postal_code: "",
        bank_residence_country: "",
        bank_residence_state: "",
        bank_residence_city: "",
        bank_address: ""
      };
      this.e1 = 1;
    }
  },

  async mounted() {
    await this[COUNTRIES__ACTIONS.COUNTRIES]();
    if (this.bankInfo.bank_residence_country) {
      await this[STATES__ACTIONS.STATES](this.bankInfo.bank_residence_country);
    }
    if (this.bankInfo.bank_residence_state) {
      await this[CITIES__ACTIONS.CITIES](this.bankInfo.bank_residence_state);
    }
  }
};
</script>

<style>
.custom-height-min{
  margin: 5px 0 50px 0 !important;
}

.mb-from{
  margin-bottom: 15px !important;
}
</style>
